<template>
  <div class="w-full h-full">
    <img src="@/assets/images/404_images/404.png" width="317px" height="200px" alt="" />
    <div class="w-full flex text-white">
      <span class="w-100px truncate text-right">关联位号：</span>
      <span class="truncate">{{ currentRelationData.code }}</span>
    </div>
    <div class="w-full flex text-white">
      <span class="w-100px truncate text-right">摄像头名称：</span>
      <span class="truncate">{{ currentRelationData.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentRelationData: {},
    }
  },
  watch: {
    transferProps: {
      handler(data) {
        this.currentRelationData = _.cloneDeep(data)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
}
</script>

<style></style>
